import { createClient } from "@supabase/supabase-js";

import { env } from "./env";
import { recordMetric } from "./telemetry";

function operationFor(input: RequestInfo | URL, init?: RequestInit) {
  const method =
    init?.method ??
    (typeof Request !== "undefined" && input instanceof Request
      ? input.method
      : "GET");
  return method.toUpperCase() === "GET" ? "read" : "write";
}

const instrumentedFetch: typeof fetch = async (input, init) => {
  const started = performance.now();
  try {
    const response = await fetch(input, init);
    void recordMetric({
      name: "api_request",
      operation: operationFor(input, init),
      status: response.ok ? "success" : "failure",
      durationMs: performance.now() - started,
    });
    return response;
  } catch (error) {
    void recordMetric({
      name: "api_request",
      operation: operationFor(input, init),
      status: "failure",
      durationMs: performance.now() - started,
    });
    throw error;
  }
};

export const supabase = createClient(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
    global: {
      headers: { "x-client-info": `capaciteo-web/${env.VITE_APP_ENV}` },
      fetch: instrumentedFetch,
    },
  },
);
